import React from 'react';
import PackageDeliveryResumeProperties from "./PackageDeliveryResumeProperties";
import {Observer} from "mobx-react-lite";
import {useStyles} from './PackageDeliveryResume.style';
import ShowPackageItemsDeliveryDetails from '../../../Info/ShowPackageItemsDeliveryDetails/ShowPackageItemsDeliveryDetails';
import PaymentsTable from '../../../Info/PaymentsTable/PaymentsTable';
import Alert from '../../../../ui_components/Alert/Alert';
import AlertType from '../../../../ui_components/Alert/AlertType';
import { useI18nContext } from '../../../../contexts/I18nContext';
import ShowInvoiceAdditionalPrices from '../../../Info/ShowInvoiceAdditionalPrices/ShowInvoiceAdditionalPrices';
import OrderAdditionalPrice from '../../../../entities/OrderAdditionalPriceRequest';


const PackageDeliveryResume: React.FC<PackageDeliveryResumeProperties> = ({
                                                                              store,
                                                                          }) => {
    const classes = useStyles();
    const i18n = useI18nContext();

    return <Observer>
        {() => (
            <div className={classes.container}>

                <ShowPackageItemsDeliveryDetails items={store.itemsAndCategories} />

                {store.additionalPrices.length > 0 &&
                    <ShowInvoiceAdditionalPrices additionalPrices={store.additionalPrices.map((p) => {
                        return new OrderAdditionalPrice(p.amount, p.comment, p.isPercentage)
                    })}></ShowInvoiceAdditionalPrices>}

                {store.payments.length > 0 &&
                    <PaymentsTable payments={store.payments} totalLabel={'Subtotal'}/>}

                 <div className={classes.alert}>
                    <Alert
                        className={classes.alert}
                        text={i18n.translate(store.validationgErrorKey)}
                        type={AlertType.DANGER}
                    />
                </div>
            </div>
        )}
    </Observer>
}

export default PackageDeliveryResume;
